export enum AnimationScope {
  BLOCK = '',
  ITEM = 'item',
}